namespace advisorop.components.advisor {


    class MultiselectCustodianDocumentsController {

        // input param
        custodianDocuments: domains.ICustodianDocument[] = [];

        // input output param
        onSelectionChanged: any;

        // helper array... selected rows
        selectedDocumentRows = [];

        // CustomDataStore as a data source for both DataGrid and DropDown
        dsCustodianDocuments: any;

        gridDropDownBoxOptions: DevExpress.ui.dxDropDownBoxOptions;
        gridDropDownBox: DevExpress.ui.dxDropDownBox;
        gridOptions: DevExpress.ui.dxDataGridOptions;

        static $inject = [];
        constructor() {
            this.setupDropDownBox();
        }

        // helper method
        makeAsyncDataSource = () => {
            //console.log("Making Custom Data Source...");
            return new DevExpress.data.CustomStore({
                loadMode: "raw",
                key: "id",
                load: () => {
                    return this.custodianDocuments;
                }
            });
        };

        setupDropDownBox() {

            this.dsCustodianDocuments = this.makeAsyncDataSource();

            this.gridDropDownBoxOptions = {
                bindingOptions: {
                    value: "vm.selectedDocumentRows",
                },
                valueExpr: "id",
                placeholder: "Select documents....",
                onValueChanged: (e) => {
                    this.valueChanged(e);
                },
                displayExpr: "name",
                contentTemplate: "availableDocumentGrid",
                showClearButton: true,
                dataSource: this.dsCustodianDocuments,
                onInitialized: (e) => {
                    this.gridDropDownBox = e.component;
                }
            };

            this.gridOptions = {
                bindingOptions: {
                    "selectedRowKeys": "vm.selectedDocumentRows"
                },
                dataSource: this.dsCustodianDocuments,
                paging: { enabled: false }, //pageSize: 15 },
                height: 200,
                scrolling: { showScrollbar: "always", useNative: true },
                columns: [
                    { dataField: "name", caption: "Document" }
                ],
                selection: { mode: "multiple", allowSelectAll: false },
                onSelectionChanged: (selectedItems) => {
                    this.selectionChange(selectedItems);
                }
            }
        }

        valueChanged(e) {
            this.selectedDocumentRows = e.value || [];
        }

        selectionChange(selectedItems) {
            //console.log("Selected Items", selectedItems);
            this.onSelectionChanged({ selectedItems: selectedItems.selectedRowsData });
        }

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
        }

        $onChanges(evt) {
            if (this.gridDropDownBox != undefined) {
                this.gridDropDownBox.getDataSource().reload();
            }
            if (this.custodianDocuments.length == 0) {
                this.selectedDocumentRows = [];
            }
        }
    }

    //title 3 types indvidual , joint more than one, custodian 
    class MultiselectCustodianDocuments implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.controller = MultiselectCustodianDocumentsController;
            this.controllerAs = "vm";
            this.bindings = {
                custodianDocuments: "<",
                onSelectionChanged: "&"
            };
            this.templateUrl = "spa/advisor-module/components/multiselect-custodian-documents.html";
        }

    }
    angular.module(Constants.APP).component("multiselectCustodianDocuments", new MultiselectCustodianDocuments());
}